<div class="flex flex-column consult__section consult__disease">
  <div class="col-12 inline-flex consult__section-subheading-group flex-wrap">
    <h3 class="col-12 inline-flex align-items-center lg:col-5 p-0 consult__section-subheading cursor-pointer"
      (click)="expandSection = !expandSection">
      <i class="fas" [style.fontSize.px]="12" [ngClass]="{
        'fa-minus': expandSection,
        'fa-plus': !expandSection
      }"></i>
      <label class="ml-2 mb-0 cursor-pointer" for="disease_{{turn}}">{{screen.heading}}</label>
    </h3>
    <span class="col-12 lg:col-7 p-0 consult__section-help">{{screen.help}}</span>
  </div>

  <span class="col-12 px-0" *ngIf="expandSection">
    <textarea pInputTextarea name="disease_{{turn}}" [(ngModel)]="value" [rows]="4" validation [readonly]="readonly"
      class="uppercase m-0" *ngIf="!readonly"></textarea>

    <span *ngIf="readonly">{{value}}</span>
  </span>
</div>